// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cegd1AlRuvd3pMlXaK2B{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    box-sizing: border-box;
    width: 100%;
    padding: 8px 8px 8px 16px;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    background-color: var(--background-regular);
}

.TdF_t9PoGHiicb209xcv{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    border: none;
    background-color: var(--background-light);
    box-sizing: border-box;
    flex-grow: 1;
    margin: 0px;


}

.v0yPpnT8xXoZJpYAiS9w{
    color: var(--letter-dark);
    outline: none;
    border: none;
    resize: none;
    box-sizing: border-box;
    display: block;
    background-color: transparent;
    font-size: 15px;
    line-height: 15px;
    margin: 0px;
    padding: 0px;
    overflow-y: auto;
    width: 100%;
    font-family: var(--quotemaster-font-family);

}


.v0yPpnT8xXoZJpYAiS9w::-webkit-scrollbar {
    width: 6px;
    border: none !important;
}

.v0yPpnT8xXoZJpYAiS9w::-webkit-scrollbar-track {
    background: transparent; /* Color of the scrollbar track */
    border: none !important;
}

.v0yPpnT8xXoZJpYAiS9w::-webkit-scrollbar-thumb {
    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */
    border: none !important;
}

.v0yPpnT8xXoZJpYAiS9w::-webkit-scrollbar-thumb:hover {
    background-color: var(--scrollbar-hover); /* Color on hover */
}

.v0yPpnT8xXoZJpYAiS9w::-webkit-scrollbar-thumb:active {
    background-color: var(--scrollbar-onClick); /* Color on click */
}

.v0yPpnT8xXoZJpYAiS9w::-webkit-scrollbar-corner {
    background-color: transparent; /* Set the corner color to match your design */
    border: 0 !important;
    box-shadow: none !important;
}

.YIeAENAFPZ7oIHm5DgTO{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--icons);
    flex-shrink: 0;
    height: 100%;
    padding: 0px;
    flex-grow: 0;
}

.YIeAENAFPZ7oIHm5DgTO:hover{
    color: var(--shopbot-main-color);
}

.Hr7MWnaIA3x32hRcElVs{
    transform: rotate(315deg);
    cursor: pointer;
}

.yw5iGgsN5_aDu4KSRvIn{
    margin-left: auto;
    cursor: pointer;
    outline: none;
    -webkit-tap-highlight-color: transparent;  /* Make tap highlight invisible */
}

.HAMfF66gfNlYxYE5cDkD{
    display: flex;
    flex-direction: column;
    justify-content: center;

}
.XZbywHKVds85lHbNZkb4{
    color: var(--icons);
    text-wrap: nowrap;
}

.Hrcel7mpy7o23fOGmhu_{
    display: flex;
    align-self: center;
    justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./clientRoot/Static/WorkingArea/ServiceOrderManagement/ChatWindows/ChatInput/ChatInput.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,+BAA+B;IAC/B,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yCAAyC;IACzC,sBAAsB;IACtB,YAAY;IACZ,WAAW;;;AAGf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,WAAW;IACX,2CAA2C;;AAE/C;;;AAGA;IACI,UAAU;IACV,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB,EAAE,iCAAiC;IAC1D,uBAAuB;AAC3B;;AAEA;IACI,0CAA0C,EAAE,kCAAkC;IAC9E,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC,EAAE,mBAAmB;AACjE;;AAEA;IACI,0CAA0C,EAAE,mBAAmB;AACnE;;AAEA;IACI,6BAA6B,EAAE,8CAA8C;IAC7E,oBAAoB;IACpB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,wCAAwC,GAAG,iCAAiC;AAChF;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;;AAE3B;AACA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,uBAAuB;AAC3B","sourcesContent":[".inputContainer{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    position: relative;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 8px 8px 8px 16px;\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n    background-color: var(--background-regular);\n}\n\n.aroundInputArea{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    border-radius: 16px;\n    border: none;\n    background-color: var(--background-light);\n    box-sizing: border-box;\n    flex-grow: 1;\n    margin: 0px;\n\n\n}\n\n.inputArea{\n    color: var(--letter-dark);\n    outline: none;\n    border: none;\n    resize: none;\n    box-sizing: border-box;\n    display: block;\n    background-color: transparent;\n    font-size: 15px;\n    line-height: 15px;\n    margin: 0px;\n    padding: 0px;\n    overflow-y: auto;\n    width: 100%;\n    font-family: var(--quotemaster-font-family);\n\n}\n\n\n.inputArea::-webkit-scrollbar {\n    width: 6px;\n    border: none !important;\n}\n\n.inputArea::-webkit-scrollbar-track {\n    background: transparent; /* Color of the scrollbar track */\n    border: none !important;\n}\n\n.inputArea::-webkit-scrollbar-thumb {\n    background-color: var(--scrollbar-regular); /* Color of the scrollbar itself */\n    border: none !important;\n}\n\n.inputArea::-webkit-scrollbar-thumb:hover {\n    background-color: var(--scrollbar-hover); /* Color on hover */\n}\n\n.inputArea::-webkit-scrollbar-thumb:active {\n    background-color: var(--scrollbar-onClick); /* Color on click */\n}\n\n.inputArea::-webkit-scrollbar-corner {\n    background-color: transparent; /* Set the corner color to match your design */\n    border: 0 !important;\n    box-shadow: none !important;\n}\n\n.inputIcons{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: var(--icons);\n    flex-shrink: 0;\n    height: 100%;\n    padding: 0px;\n    flex-grow: 0;\n}\n\n.inputIcons:hover{\n    color: var(--shopbot-main-color);\n}\n\n.sendIcon{\n    transform: rotate(315deg);\n    cursor: pointer;\n}\n\n.micIcon{\n    margin-left: auto;\n    cursor: pointer;\n    outline: none;\n    -webkit-tap-highlight-color: transparent;  /* Make tap highlight invisible */\n}\n\n.recordingLabel{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n}\n.cancelText{\n    color: var(--icons);\n    text-wrap: nowrap;\n}\n\n.recordingTime{\n    display: flex;\n    align-self: center;\n    justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `Cegd1AlRuvd3pMlXaK2B`,
	"aroundInputArea": `TdF_t9PoGHiicb209xcv`,
	"inputArea": `v0yPpnT8xXoZJpYAiS9w`,
	"inputIcons": `YIeAENAFPZ7oIHm5DgTO`,
	"sendIcon": `Hr7MWnaIA3x32hRcElVs`,
	"micIcon": `yw5iGgsN5_aDu4KSRvIn`,
	"recordingLabel": `HAMfF66gfNlYxYE5cDkD`,
	"cancelText": `XZbywHKVds85lHbNZkb4`,
	"recordingTime": `Hrcel7mpy7o23fOGmhu_`
};
export default ___CSS_LOADER_EXPORT___;
